window.recalculateMonthlyCost = function recalculateMonthlyCost() {
    var mileage_input = $('#effMileage'),
        monthly_cost = ((isNaN(mileage_input.val()) ? 0 : mileage_input.val()) * mileage_input.attr('data-price') * 3.78541178) / (100 * 12 * mileage_input.attr('data-mpg'));

    $('#affordabilityMonthlyFuel').html('\u00A3' + monthly_cost.toFixed(2));
}

$(document).ready(function () {
    'use strict';

    $('#affordabilityCalculator').submit(function(e) {
        e.preventDefault();
        recalculateMonthlyCost();
    });

    $('#effMileage').focus(function() {
        dataLayer.push({'event': 'Affordability calculator calculate'});
    });

    $('#effMileage').keyup(function(e) {
        recalculateMonthlyCost();
    });
});